import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col, Container, Accordion, Button } from 'react-bootstrap';
import { appConfig } from '../../config/app';
import HomepageVideoCard from '../HomepageVideoCard';
import HeroVideoSection from './HeroVideoSection';

//import StaticAPI_desktop from "./StaticAPI_desktop.js";
//import SQLAPI_desktop from "./SQLAPI_desktop.js";
//import VariableAPI_desktop from "./VariableAPI_desktop.js";

const Home = ({auth}) => {    
    // Toggle for video hero - can be controlled via environment variable or config
    const USE_VIDEO_HERO = appConfig.features.useVideoHero;

    return (
        <>
            {/* Hero Section - Toggle between video and text versions */}
            {USE_VIDEO_HERO ? (
                <HeroVideoSection />
            ) : (
                <section className="hero-section pb-5">
                    <Container>
                        <Row className="justify-content-center pt-2 pb-5">
                            <Col xs={12} lg={12} xl={10}>
                                <div className="text-center pt-4">
                                    <h1 className="display-1">
                                        Your fantasy league <span className="text-gradient">RecapVid</span>
                                    </h1>
                                    <p className="lead">
                                        {appConfig.brand.description}
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link to="/onboarding/platform" className="d-block">
                                            <Button 
                                                className="btn-primary-gradient btn-lg"
                                                style={{
                                                    fontSize: "1.1rem", 
                                                    fontWeight: "600",
                                                    padding: "16px 32px",
                                                    width: "auto"
                                                }}
                                            >
                                                Get Started
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Sample Video Section - Only show if using text hero */}
            {!USE_VIDEO_HERO && (
                <HomepageVideoCard 
                    videoUrl={appConfig.sampleVideo.url}
                    title={appConfig.sampleVideo.title}
                    description={appConfig.sampleVideo.description}
                />
            )}

            {/* Why You'll Love It Section */}
            <section className="pt-5" style={{paddingBottom: '8rem'}}>
                <Container>
                    <Row className="pt-5 justify-content-center">
                        <Col xs={12} lg={12}>
                            {/*}
                            <div className="text-center mb-5">
                                <h2 className="display-2 mb-4">
                                    Be the <span className="text-gradient">coolest commissioner</span>
                                </h2>
                                <p className="lead mb-5">Get your league laughing with recaps that make fun of each team equally. 🏈 {appConfig.product.currentSport} only for now.</p>
                            </div>
                            */}
                            <Row className="g-4">
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100">
                                        <div className="feature-icon mb-5 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-video fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>2 minutes of Pure Entertainment</h3>
                                        <p className="text-muted flex-grow-1">Short, sweet, and packed with laughs. Perfect for your morning coffee or lunch break.</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100">
                                        <div className="feature-icon mb-5 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-users fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>Personalized for Your League</h3>
                                        <p className="text-muted flex-grow-1">Our AI analyzes your league data to create recaps tailored to your specific teams, players, and inside jokes.</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="mb-4">
                                    <div className="feature-card text-center d-flex flex-column h-100">
                                        <div className="feature-icon mb-5 flex-shrink-0" style={{minHeight: '80px', paddingTop: '20px'}}>
                                            <i className="fas fa-share-alt fa-3x text-primary"></i>
                                        </div>
                                        <h3 className="h4 mb-3 flex-shrink-0" style={{minHeight: '60px'}}>Easy to Share</h3>
                                        <p className="text-muted flex-grow-1">Download the video and upload to YouTube, TikTok, Facebook, Instagram, X, or wherever you want. Tag us and we'll like and repost!</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Features Section */}
            <section className="pb-5 bg-dark" style={{paddingTop: '8rem'}}>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} lg={12}>
                            <div className="text-center mb-5">
                                <h2 className="display-2 mb-4">
                                    Powerful features that make <span className="text-gradient">fantasy football</span> more enjoyable
                                </h2>
                            </div>
                            <Row className="g-4">
                                <Col xs={12} md={6} className="mb-4">
                                    <div className="feature-card d-flex flex-column h-100" style={{padding: '20px'}}>
                                        <div className="d-flex align-items-start">
                                            <div className="feature-icon me-3 flex-shrink-0" style={{width: '40px', textAlign: 'center'}}>
                                                <i className="fas fa-chart-line fa-2x text-primary"></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h3 className="h5 mb-2">Performance Analytics</h3>
                                                <p className="text-muted mb-0">Deep insights into player performance and league trends.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} className="mb-4">
                                    <div className="feature-card d-flex flex-column h-100" style={{padding: '20px'}}>
                                        <div className="d-flex align-items-start">
                                            <div className="feature-icon me-3 flex-shrink-0" style={{width: '40px', textAlign: 'center'}}>
                                                <i className="fas fa-trophy fa-2x text-primary"></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h3 className="h5 mb-2">Winner Celebrations</h3>
                                                <p className="text-muted mb-0">Celebrate the champions and roast the losers.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} className="mb-4">
                                    <div className="feature-card d-flex flex-column h-100" style={{padding: '20px'}}>
                                        <div className="d-flex align-items-start">
                                            <div className="feature-icon me-3 flex-shrink-0" style={{width: '40px', textAlign: 'center'}}>
                                                <i className="fas fa-download fa-2x text-primary"></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h3 className="h5 mb-2">Downloadable Video</h3>
                                                <p className="text-muted mb-0">Share how, where, and with who you want.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} className="mb-4">
                                    <div className="feature-card d-flex flex-column h-100" style={{padding: '20px'}}>
                                        <div className="d-flex align-items-start">
                                            <div className="feature-icon me-3 flex-shrink-0" style={{width: '40px', textAlign: 'center'}}>
                                                <i className="fas fa-clock fa-2x text-primary"></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h3 className="h5 mb-2">Weekly Updates</h3>
                                                <p className="text-muted mb-0">Fresh content every week during the season.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            
                            {/* CTA Section integrated into features */}
                            <Row className="justify-content-center mt-5">
                                <Col xs={12} lg={12}>
                                    <div className="text-center" style={{paddingTop: '4rem', paddingBottom: '3rem'}}>
                                        <h2 className="display-2 mb-4">
                                            Ready to make your league <span className="text-gradient">legendary</span>?
                                        </h2>
                                        <p className="lead mb-4">Be a part of the first leagues to use AI-powered {appConfig.brand.name} and make your league way more fun this season.</p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/onboarding/platform" className="d-block">
                                                <Button 
                                                    className="btn-primary-gradient btn-lg"
                                                    style={{
                                                        fontSize: "1.1rem", 
                                                        fontWeight: "600",
                                                        padding: "16px 32px",
                                                        width: "auto"
                                                    }}
                                                >
                                                    Get Started →
                                                </Button>
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* FAQ Section */}
            <section className="py-5" id="faq">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} lg={12}>
                            <div className="text-center mb-5">
                                <h2 className="display-2 mb-4">
                                    Frequently Asked <span className="text-gradient">Questions</span>
                                </h2>
                                <p className="lead">Everything you need to know about {appConfig.brand.name}</p>
                            </div>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>How does the weekly recap work?</Accordion.Header>
                                    <Accordion.Body className="pt-3">Every week, our AI analyzes your fantasy football league's performance and automatically creates a personalized recap video around 2-3 minutes. We roast everyone equally (keeping it clean and fun) and highlight the most exciting moments from your league.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>How long are the recap videos?</Accordion.Header>
                                    <Accordion.Body className="pt-3">Our recaps are typically 2-3 minutes, but the exact length varies each week depending on the content. We keep it short and sweet because we know you're busy - perfect for watching during your morning coffee or lunch break!</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>What fantasy platforms do you support?</Accordion.Header>
                                    <Accordion.Body className="pt-3">We currently support Sleeper fantasy leagues. We plan to support more platforms soon. Go to our Discord to tell us which platform you'd like us to add next!</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Can I share the recaps with my league?</Accordion.Header>
                                    <Accordion.Body className="pt-3">Absolutely! Each recap is designed to be shared anywhere - upload to YouTube, post on social media, send to your group chat, or watch together during your next league meeting.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>How much does it cost?</Accordion.Header>
                                    <Accordion.Body className="pt-3">It costs $10 per month and that includes 1 video every Tuesday BY 1pm ET, so depending when your subscription renews, it'll be 4 or 5 videos per month.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>How can I get a $10 credit when I sign up?</Accordion.Header>
                                    <Accordion.Body className="pt-3">We're offering a $10 Venmo credit to early users! After you sign up and pay, simply contact our founder in <a href={appConfig.social.discord} target="_blank" rel="noopener noreferrer" style={{color: 'var(--accent-primary)', textDecoration: 'none'}}>Discord</a> or email us at <a href={`mailto:${appConfig.contact.primary.email}`} style={{color: 'var(--accent-primary)', textDecoration: 'none'}}>{appConfig.contact.primary.email}</a> to claim your credit. This offer is available before we add our free trial feature.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="6">
                                    <Accordion.Header>How will I know when my video is ready?</Accordion.Header>
                                    <Accordion.Body className="pt-3">You can check your dashboard for updates. Our system is set up to generate videos by 1pm ET on Tuesdays, so you can expect to see your weekly recap video available around that time. A future update we're planning is to notify you when your video is ready via email. Go to our Discord and tell us how much you want this. Squeaky wheel gets the grease.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="7">
                                    <Accordion.Header>Can I change the video announcer or script?</Accordion.Header>
                                    <Accordion.Body className="pt-3">This is a brand new product and we're releasing updates regularly. Right now, you can't, but we want to add those features and more. Join the Discord to tell us what you want us to build!</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="8">
                                    <Accordion.Header>Can I get AI video summaries for my company's data?</Accordion.Header>
                                    <Accordion.Body className="pt-3">Yes! We offer enterprise AI video solutions that can transform your company's data into compelling video summaries. Our services include highlighting key metrics, identifying insights, and summarizing performance with enterprise-grade data privacy protections. <a href="#enterprise" style={{color: 'var(--accent-primary)', textDecoration: 'none'}}>Learn more about our Enterprise AI Video Solutions →</a></Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="9">
                                    <Accordion.Header>How do you keep my payment information secure?</Accordion.Header>
                                    <Accordion.Body className="pt-3">We use Stripe for all credit card processing. Stripe is PCI DSS compliant, and they are considered to beone of the most trusted payment processors in the world. Your payment information is never stored on our servers.</Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Community Section */}
            <section className="py-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} lg={12}>
                            <div className="text-center">
                                <h2 className="display-2 mb-4">
                                    Join the <span className="text-gradient">community</span>
                                </h2>
                                <p className="lead mb-4">Connect with other fantasy football enthusiasts, get early access to features, and share your league's best moments.</p>
                                <div className="d-flex justify-content-center">
                                    <a 
                                        href={appConfig.social.discord}
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="btn btn-primary-gradient btn-lg"
                                    >
                                        <i className="fab fa-discord me-2"></i>
                                        Join Our Discord
                                    </a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Home);
